import Vue from 'vue';
import Vuex from 'vuex';
import loadingPlugin from './plugins/loadingPlugin';

import project from './project/project';
import page from './page/index';
import app from './app';
import env from './env';
import version from './version';
import ui from './ui';
import runtime from './runtime';
import rbac from '../pages/modules/permission/module';
import plugin from './plugin';
import template from './template';
import draft from './drafts';
import projectModifyRecord from './projectModifyRecord';
import componentHub from './componenthub';
import componentProjectLock from './component-project-lock';
import projectGroup from './projectGroup/index';
import miniprogram from './miniprogram/miniprogram';
import compTemplate from './compTemplate';
import branch from './branch';
import subProject from './subProject/subProject';
import globalSearch from './globalSearch';
import navigation from './navigation';
import layout from './layout';
import announcement from './announcement';
import datatable from './datatable';
import material from './material';
import dataSource from './dataSource';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    project,
    page,
    ui,
    app,
    env,
    version,
    runtime,
    rbac,
    plugin,
    template,
    draft,
    projectModifyRecord,
    componentHub,
    projectGroup,
    miniprogram,
    compTemplate,
    branch,
    material,
    subProject,
    globalSearch,
    componentProjectLock,
    navigation,
    layout,
    announcement,
    datatable,
    dataSource,
  },
  plugins: [loadingPlugin],
});

export default store;

export const useStore = () => store;
